import { render, staticRenderFns } from "./ProductionFormulationListTab.vue?vue&type=template&id=bb6f55f6&"
import script from "./ProductionFormulationListTab.vue?vue&type=script&lang=js&"
export * from "./ProductionFormulationListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports